import React from "react";
import { useLanguage } from "../context/LanguageContext";
import { useModal } from "../context/ModalContext";

const Hero = () => {
  const { translateHTML, translate } = useLanguage();
  const { openModal } = useModal();

  const handleLearnMore = () => {
    openModal("learn-more", {});
  };

  // Simple fallback tanpa external URL
  const handleImageError = (e) => {
    e.target.style.display = "none";

    // Buat div placeholder
    const parent = e.target.parentElement;

    // Hapus semua child
    while (parent.firstChild) {
      parent.removeChild(parent.firstChild);
    }

    // Buat div placeholder dengan CSS gradient
    const placeholder = document.createElement("div");
    placeholder.style.cssText = `
      width: 100%;
      height: 300px;
      background: linear-gradient(135deg, var(--light-blue) 0%, var(--white) 100%);
      border-radius: 15px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: var(--dark-blue);
      font-size: 24px;
      font-weight: bold;
      box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
      padding: 20px;
      text-align: center;
    `;

    const logo = document.createElement("div");
    logo.style.cssText = `
      background: var(--gradient-blue);
      color: white;
      width: 80px;
      height: 80px;
      border-radius: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: 'Montserrat', sans-serif;
      font-weight: 900;
      font-size: 40px;
      margin-bottom: 20px;
      box-shadow: 0 10px 20px rgba(26, 107, 255, 0.3);
    `;
    logo.textContent = "S";

    const text = document.createElement("div");
    text.textContent = "SAKAKA IT Solutions";
    text.style.fontSize = "28px";
    text.style.marginBottom = "10px";

    const subtext = document.createElement("div");
    subtext.textContent = "Transformasi Digital untuk Bisnis Anda";
    subtext.style.fontSize = "16px";
    subtext.style.color = "var(--dark-gray)";
    subtext.style.opacity = "0.8";

    placeholder.appendChild(logo);
    placeholder.appendChild(text);
    placeholder.appendChild(subtext);
    parent.appendChild(placeholder);
  };

  return (
    <section className="hero" id="home">
      <div className="container hero-content">
        <div className="hero-text">
          <h1 dangerouslySetInnerHTML={translateHTML("hero-title")}></h1>
          <p>{translate("hero-desc")}</p>

          <button className="learn-more-btn" onClick={handleLearnMore}>
            <i className="fas fa-arrow-right"></i>{" "}
            <span>{translate("learn-more")}</span>
          </button>

          <div style={{ marginTop: "20px", fontSize: "0.9rem", color: "#666" }}>
            <p>
              <i
                className="fas fa-check-circle"
                style={{ color: "var(--primary-blue)", marginRight: "5px" }}
              ></i>{" "}
              {translate("feature1")}
            </p>
            <p>
              <i
                className="fas fa-check-circle"
                style={{ color: "var(--primary-blue)", marginRight: "5px" }}
              ></i>{" "}
              {translate("feature2")}
            </p>
          </div>
        </div>
        <div className="hero-image">
          <img
            src="https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80"
            alt="SAKAKA IT Solutions"
            loading="lazy"
            onError={handleImageError}
          />
        </div>
      </div>
    </section>
  );
};

export default Hero;
